import { jsx as i, jsxs as n } from "react/jsx-runtime";
import { memo as d } from "react";
import { u as o } from "../styled-components.browser.esm-3eb04950.js";
const f = d(({ breadcrumb: e, alignment: t, children: r }) => /* @__PURE__ */ i(x, { children: /* @__PURE__ */ n(a, { children: [
  e,
  /* @__PURE__ */ i(l, { $alignment: t, children: r })
] }) })), l = o.div`
  display: flex;
  flex-grow: 1;
  min-height: 0;
  gap: 24px;
  flex-direction: row;
  overflow: hidden;
  justify-content: ${({ $alignment: e }) => e || "center"};
  align-items: center;

  @media (max-width: 1600px) {
    flex-direction: column;
  }
`, a = o.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  overflow: hidden;

  @media (max-width: 1200px) {
    gap: 10px;
  }
`, x = o.div`
  border-left: 1px solid var(--border-color-base);
  padding: 40px;
  margin: 0;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;
export {
  f as default
};
//# sourceMappingURL=AdministrationLayout.js.map
